import Logo from "assets/images/Logo";

/** The wordmark is drawn in `currentColor`: it takes the surrounding text
 *  colour (text.primary — #171923 / #f7fafc, was #000 / #fff). */
const LogoComponent = () => {
  return <Logo fill="currentColor" />;
};

export default LogoComponent;
